import { DEFAULT_TRANSITION } from '../../styles/constants';

export const MAIN_HEADER_ANIMATION = {
  unMounted: { opacity: 0, y: 0 },
  mounted: {
    opacity: 1,
    y: 0,
    transition: { delay: 1, ...DEFAULT_TRANSITION },
  },
};
